<template>
  <div class="quote-container pcb-quote" v-loading="loading">
    <el-form 
      id="quoteForm" 
      class="quote-container__left" 
      size="small" 
      label-width="125px"
      v-anchorNav="isPcbSite ? {
        dir_basicInfo: '基本信息',
        dir_processInfo: '工艺信息',
        dir_serviceInfo: '服务信息',
      } : {}"
    >
      <!-- 基本信息 -->
      <div id="dir_basicInfo" class="quote-container__content">
        <div class="quote-container__header">
          <p>
            PCB下单<span>(硬板)</span>
          </p>
          <div class="quote-container__header__right">
            <div v-if="isPcbSite" class="quote-container__header__newversion" @click="handleGoNewversion">
              <span>新版下单上线，立即体验</span>
              <img :src="require('@@/assets/img/icons/icon_jump.png')" />
            </div>
            <BaseLink v-if="isShowMustSeeLink" href="https://www.hqpcb.com/help/c_59.html" target="_blank">
              下单必看
              <i class="el-icon-d-arrow-right" />
            </BaseLink>
          </div>
        </div>
        <!-- 下单必看提示 -->
        <MustSeeTips @hide="isShowMustSeeLink = true" />
        <!-- SMT贴片 -->
        <is_need_smt 
          v-if="!isPcbSite" 
          ref="is_need_smt" 
          v-model="pcbParams.is_need_smt" 
          :pcbParams="pcbParams" 
        />
        <!-- PCB文件 -->
        <pcbfile 
          v-model="pcbParams.pcbfile" 
          :analyze_id.sync="pcbParams.analyze_id"
          @analyzeSuccess="handleAnalyzeFile"
          @analyze3DComplete="handleAnalyze3DComplete"
          @analyzeing3D="isLoading => iframe3DConfig.loading = isLoading"
        />
        <!-- 产品类别 -->
        <board_type v-model="pcbParams.board_type" @change="handleBoardTypeChange" />

        <!-- Rogers 相关字段 -->
        <template v-if="isShow.isRogers">
          <!-- 混压类型 -->
          <rogers_hybrid_type v-model="pcbParams.hybrid_type" />
          <!-- 板子层数 -->
          <rogers_blayer 
            v-model="pcbParams.blayer" 
            :hybrid_type="pcbParams.hybrid_type" 
            :initPcbParamsChange="initPcbParamsChange" 
          />
          <!-- 板材型号 -->
          <rogers_board_model v-model="pcbParams.board_model" />
        </template>
      
        <!-- FR-4 相关字段 -->
        <template v-if="isShow.isFr4">
          <!-- 板子层数 -->
          <blayer 
            v-model="pcbParams.blayer" 
            :blind="pcbParams.blind" 
            :initPcbParamsChange="initPcbParamsChange" 
          />
          <!-- HDI(盲埋孔) -->
          <blind 
            v-model="pcbParams.blind" 
            :isHdi="isHdi" 
            :blayer="pcbParams.blayer" 
            :initPcbParamsChange="initPcbParamsChange" 
          />
          <!-- 板材 -->
          <board 
            ref="board"
            :board_brand.sync="pcbParams.board_brand" 
            :board_tg.sync="pcbParams.board_tg" 
            :board_model.sync="pcbParams.board_model" 
            :params="{
              blayer: pcbParams.blayer,
              blind: pcbParams.blind,
              bheight: pcbParams.bheight,
              copper: pcbParams.copper,
              insidecopper: pcbParams.insidecopper
            }"
            :initPcbParamsChange="initPcbParamsChange"
          />
        </template>

        <!-- 板子层数 -->
        <cem1_blayer 
          v-if="isShow.isCem1OrCem3OrFr1Or22f"
          v-model="pcbParams.blayer" 
          :initPcbParamsChange="initPcbParamsChange" 
        />
       
        <!-- 拼板款数 -->
        <pbnum ref="pbnum" v-model="pcbParams.pbnum" />
        <!-- 出货形式 -->
        <units 
          v-model="pcbParams.units" 
          @open="handleOpenBoardDialog"
          @reset="handleResetBoard"
        />
        <!-- 连片类型 -->
        <delivery_sub_units 
          v-if="isShow.delivery_sub_units"
          ref="delivery_sub_units"
          v-model="pcbParams.delivery_sub_units" 
        />
        <!-- 尺寸 -->
        <length 
          ref="length" 
          :length.sync="pcbParams.length" 
          :width.sync="pcbParams.width" 
          :units="pcbParams.units" 
          :disabled="isDisabledBoardParams"
          :areaTips="areaTips"
        />
        <!-- 拼板规则 -->
        <layout
          v-if="isShow.layout"
          ref="layout"
          :layoutx.sync="pcbParams.layoutx"
          :layouty.sync="pcbParams.layouty"
          :exampleData="{
            setlength: computePcbSize.length,
            setwidth: computePcbSize.width,
            length: pcbParams.length,
            width: pcbParams.width,
            layouty: pcbParams.layouty,
            layoutx: pcbParams.layoutx,
            bcount: pcbParams.bcount,
            pcsNum: pcsNumForSet,
            m: pcbPrice.m
          }"
          :disabled="isDisabledBoardParams"
        />
        <!-- 数量 -->
        <bcount 
          ref="bcount"
          v-model="pcbParams.bcount" 
          :blayer="pcbParams.blayer" 
          :units="pcbParams.units" 
          :setlength="computePcbSize.length"
          :setwidth="computePcbSize.width"
          :pcsNum="pcsNumForSet" 
          :area="area"
          :ladderPriceData="{
            blayer: pcbParams.blayer,
            length: computePcbSize.length,
            width: computePcbSize.width,
            bcount: pcbParams.bcount,
            bheight: pcbParams.bheight
          }"
          :board_type="pcbParams.board_type"
          :areaTips="areaTips"
          @tipsChange="tips => ladderPriceTips = tips"
        />
        <!-- 工艺边框 -->
        <sidewidth 
          ref="sidewidth" 
          v-if="isShow.sidewidth" 
          :sidedirection.sync="pcbParams.sidedirection" 
          :sidewidth.sync="pcbParams.sidewidth" 
          :disabled="isDisabledBoardParams"
          :hasDfmSets="hasDfmSets"
          :dfm_sets="pcbParams.dfm_sets"
        />
      </div>

      <!-- 工艺信息 -->
      <div id="dir_processInfo" class="quote-container__content">
        <i class="quote-container__linker"></i>
        <p class="quote-container__title">工艺信息</p>

        <!-- 板子厚度 -->
        <component 
          ref="bheight"
          :is="getComponentName('bheight')"
          v-model="pcbParams.bheight"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              copper: pcbParams.copper,
              insidecopper: pcbParams.insidecopper,
              color: pcbParams.color,
              bankong: pcbParams.bankong,
              baobian: pcbParams.baobian,
              vias: pcbParams.vias,
              area: area,
              initPcbParamsChange: initPcbParamsChange,
              initDefaultPcbParamsChange: initDefaultPcbParamsChange
            },
            'ROGERS': {
              blayer: pcbParams.blayer,
              board_model: pcbParams.board_model,
              initPcbParamsChange: initPcbParamsChange,
              initDefaultPcbParamsChange: initDefaultPcbParamsChange
            },
            'CEM-3': {
              board_type: pcbParams.board_type,
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 外层铜厚 -->
        <component 
          :is="getComponentName('copper')"
          v-model="pcbParams.copper"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              blind: pcbParams.blind,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              blayer: pcbParams.blayer,
              initPcbParamsChange: initPcbParamsChange
            },
            'CEM-3': {
              board_type: pcbParams.board_type,
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 内层铜厚 -->
        <component 
          v-if="isShow.insidecopper"
          ref="insidecopper"
          :is="getComponentName('insidecopper')"
          v-model="pcbParams.insidecopper"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              blind: pcbParams.blind,
              copper: pcbParams.copper,
              bheight: pcbParams.bheight,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {}
          }[pcbParams.board_type] || {}"
        />

        <!-- 最小线宽/线距 -->
        <component 
          :is="getComponentName('lineweight')"
          v-model="pcbParams.lineweight"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              blind: pcbParams.blind,
              copper: pcbParams.copper,
              insidecopper: pcbParams.insidecopper,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              copper: pcbParams.copper,
              area: area,
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 线路工艺 -->
        <cem1_circuit_patterning_process 
          v-if="isShow.circuit_patterning_process"
          v-model="pcbParams.circuit_patterning_process"
          :lineweight="pcbParams.lineweight"
          :initPcbParamsChange="initPcbParamsChange"
        />

        <!-- 最小孔径 -->
        <component 
          :is="getComponentName('vias')"
          v-model="pcbParams.vias"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              blind: pcbParams.blind,
              bheight: pcbParams.bheight,
              copper: pcbParams.copper,
              insidecopper: pcbParams.insidecopper,
              color: pcbParams.color,
              area: area,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              bheight: pcbParams.bheight,
              initPcbParamsChange: initPcbParamsChange
            },
            'CEM-3': {
              board_type: pcbParams.board_type,
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 阻焊颜色 -->
        <component 
          :is="getComponentName('color')"
          v-model="pcbParams.color"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              bheight: pcbParams.bheight,
              copper: pcbParams.copper,
              vias: pcbParams.vias,
              area: area,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 字符颜色 -->
        <component 
          :is="getComponentName('charcolor')"
          v-model="pcbParams.charcolor" 
          v-bind="{
            'FR-4': {
              color: pcbParams.color,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              color: pcbParams.color,
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 阻焊覆盖 -->
        <component 
          v-if="isShow.cover"
          :is="getComponentName('cover')"
          v-model="pcbParams.cover"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              copper: pcbParams.copper,
              insidecopper: pcbParams.insidecopper,
              spray: pcbParams.spray,
              via_in_pad: pcbParams.via_in_pad,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 盘中孔-->
        <via_in_pad
          v-if="isShow.via_in_pad"
          v-model="pcbParams.via_in_pad"
          :blayer="pcbParams.blayer"
          :copper="pcbParams.copper"
          :insidecopper="pcbParams.insidecopper"
          :initPcbParamsChange="initPcbParamsChange" 
        />

        <!-- 表面处理 -->
        <component 
          :is="getComponentName('spray')"
          v-model="pcbParams.spray"
          v-bind="{
            'FR-4': {
              blayer: pcbParams.blayer,
              bankong: pcbParams.bankong,
              baobian: pcbParams.baobian,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 沉金厚度 -->
        <component 
          v-if="isShow.cjh"
          :is="getComponentName('cjh')"
          v-model="pcbParams.cjh"
          v-bind="{
            'FR-4': {
              manufacture: manufacture,
              initPcbParamsChange: initPcbParamsChange
            },
            'ROGERS': {
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 成型方式 -->
        <cem1_forming_method 
          v-if="isShow.forming_method"
          v-model="pcbParams.forming_method"
        />

        <!-- 层压顺序 -->
        <overlay_type
          ref="overlay_type"
          v-if="isShow.overlay_type"
          :overlay_type.sync="pcbParams.overlay_type"
          :overlay_seq.sync="pcbParams.overlay_seq"
        />
        <!-- 阻抗 -->
        <impendance 
          v-if="isShow.impendance"
          v-model="pcbParams.impendance" 
          :blayer="pcbParams.blayer"
          :copper="pcbParams.copper" 
          :pressing="pcbParams.pressing"
          :showTips="isShow.isFr4"
          :initPcbParamsChange="initPcbParamsChange"
        />

        <!-- 叠层结构 -->
        <component 
          ref="pressing"
          v-if="isShow.pressing"
          :is="getComponentName('pressing')"
          v-model="pcbParams.pressing"
          v-bind="{
            'FR-4': {
              params: { 
                blayer: pcbParams.blayer, 
                bheight: pcbParams.bheight, 
                copper: pcbParams.copper, 
                insidecopper: pcbParams.insidecopper, 
                hdi: pcbParams.blind 
              },
              pressingData: pcbParams.pressing_data,
            },
            'ROGERS': {
              initPcbParamsChange: initPcbParamsChange
            }
          }[pcbParams.board_type] || {}"
        />

        <!-- 手指斜边 -->
        <beveledge 
          ref="beveledge"
          v-if="isShow.beveledge" 
          v-model="pcbParams.beveledge" 
          :board_type="pcbParams.board_type"
          :pcb-size="computePcbSize" 
        />
        <!-- 半孔 -->
        <bankong 
          v-if="isShow.bankong"
          v-model="pcbParams.bankong" 
          :blayer="pcbParams.blayer"
          :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
          :initPcbParamsChange="initPcbParamsChange"  
        />
        <!-- 包边 -->
        <baobian 
          v-if="isShow.baobian"
          v-model="pcbParams.baobian" 
          :blayer="pcbParams.blayer"
          :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
          :initPcbParamsChange="initPcbParamsChange"  
        />
        <!-- 压接孔 -->
        <press_fit_hole 
          ret="press_fit_hole"
          v-if="isShow.press_fit_hole"
          v-model="pcbParams.press_fit_hole" 
          :spray="pcbParams.spray"
          :bankong="pcbParams.bankong"
          :baobian="pcbParams.baobian"
          :initPcbParamsChange="initPcbParamsChange"  
        />

        <!-- 蓝胶 -->
        <rogers_blue_glue v-if="isShow.blue_glue" v-model="pcbParams.blue_glue" />
        <!-- 碳油 -->
        <rogers_carbon_oil v-if="isShow.carbon_oil" v-model="pcbParams.carbon_oil" />
      </div>

      <!-- 服务信息 -->
      <div id="dir_serviceInfo" class="quote-container__content">
        <i class="quote-container__linker"></i>
        <p class="quote-container__title">服务信息</p>

        <!-- 测试方式 -->
        <component 
          :is="getComponentName('test')"
          v-model="pcbParams.test"
          :testOptions="testOptions"
        />

        <!-- 确认生产稿 -->
        <review_file 
          ref="review_file" 
          v-model="pcbParams.review_file" 
          :board_type="pcbParams.board_type"
          :blayer="pcbParams.blayer"
          :user_stamp="pcbParams.user_stamp"
          :panelize_method="pcbParams.panelize_method"
          :initPcbParamsChange="initPcbParamsChange"
        />
        <!-- 产品报告 -->
        <report 
          v-model="pcbParams.report" 
          :blayer="pcbParams.blayer" 
          :impendance="pcbParams.impendance"
          :initPcbParamsChange="initPcbParamsChange" 
        />
        <!-- 报告形式 -->
        <report_type 
          ref="report_type" 
          v-if="isShow.report_type" 
          v-model="pcbParams.report_type" 
        />
        <!-- 打叉板 -->
        <cross_board 
          v-model="pcbParams.cross_board" 
          :board_type="pcbParams.board_type"
        />

        <!-- 隔白纸 -->
        <paper 
          ref="paper"
          v-model="pcbParams.paper"
          :length="pcbParams.length" 
          :width="pcbParams.width"
        />

        <!-- 客编 -->
        <user_stamp 
          ref="user_stamp" 
          v-model="pcbParams.user_stamp" 
          :board_type="pcbParams.board_type"
        />
        <!-- 产品标签 -->
        <inner_box_label 
          v-if="isShow.inner_box_label"
          ref="inner_box_label"
          :inner_box_label.sync="pcbParams.inner_box_label" 
          :custom_id.sync="pcbParams.custom_id" 
          :custom_name.sync="pcbParams.custom_name" 
        />
        <!-- 少数处理方式 -->
        <lack_handle_type 
          v-if="isShow.lack_handle_type"
          ref="lack_handle_type" 
          :lack_handle_type.sync="pcbParams.lack_handle_type"
          :lack_handle_number_type.sync="pcbParams.lack_handle_number_type"
          :lack_handle_number.sync="pcbParams.lack_handle_number"
          :lack_handle_number_unit.sync="pcbParams.lack_handle_number_unit"
          :lack_handle_shipping_type.sync="pcbParams.lack_handle_shipping_type"
          :units="pcbParams.units" 
          :bcount="pcbParams.bcount" 
          :layouty="pcbParams.layouty" 
          :layoutx="pcbParams.layoutx" 
        />
        <!-- 订单支付方式 -->
        <deduct_type 
          ref="deduct_type"
          :deduct_type.sync="pcbParams.deduct_type" 
          :deduct_limit.sync="pcbParams.deduct_limit" 
          :price-total="priceTotal.total_amount"
        />
        
        <!-- 品质赔付方式 -->
        <insurance_type 
          v-if="isShow.insurance_type"
          :insurance_type.sync="pcbParams.insurance_type" 
          :insurance.sync="pcbParams.insurance" 
          :pcbParams="pcbParams"
        />

        <!-- SMT贴片 -->
        <is_need_smt 
          v-if="isPcbSite" 
          ref="is_need_smt" 
          v-model="pcbParams.is_need_smt" 
          :pcbParams="pcbParams" 
          @reviewFileChange="val => pcbParams.review_file = val"
        />
      </div>

      <!-- SMT信息 -->
      <div v-if="isNeedSmt" class="quote-container__content">
        <i class="quote-container__linker"></i>
        <p class="quote-container__title">SMT信息</p>
        <SmtForm ref="smtFormRef" :data="smtParams" />
      </div>
    </el-form>

    <affix :offset="89" relativeContainerId="quoteForm">
      <Iframe3D 
        v-if="iframe3DConfig.isShow" 
        :loading="iframe3DConfig.loading"
        :analyzeId="iframe3DConfig.analyze_id"
        :analyzeKey="iframe3DConfig.key"
        :params="{
          type: pcbParams.board_type,
          height: pcbParams.bheight,
          color: pcbParams.color,
          pad: pcbParams.spray
        }"
      />
      <QuoteRight :type="isNeedSmt ? 'PCB_SMT' : 'PCB'" />
    </affix>

    <AffixService v-if="isPcbSite" />
    <!-- 拼板工具弹框 -->
    <BoardDialog 
      ref="BoardDialogRef" 
      :pcbParams="pcbParams" 
      :hasDfmSets="hasDfmSets"
      @confirm="handleBoardConfirm"
      @cancel="handleBoardCancel"
    />
  </div>
</template>

<script>
// 下单必看提示
import MustSeeTips from '@@/components/mustSeeTips/index'
// 右侧固钉悬浮
import Affix from '@@/components/affix/index'
// smt信息
import SmtForm from './smtForm'
// 计价页右侧
import QuoteRight from '@@/views/quoteRight/index'
// 计价页右侧 3D渲染iframe
import Iframe3D from './components/iframe3D'
// 右侧悬浮专属客服
import AffixService from './components/affixService.vue'
// 拼板工具弹框
import BoardDialog from './components/boardDialog/index'

import { isPcbSite } from '@@/utils/is'
import { sensorsTrack } from '@@/utils/sensors'
import { debounce } from '@@/utils/utils'
import { scrollTop } from '@@/utils/pageScroll'
import { getNumberOptionKeys } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'
import { anchorNav } from '@@/utils/directives'
import { registerComponents } from '@@/utils/registerComponents'
import {
  ORDER_TYPE_ENUMS,
  UNCHANGED_FIELDS
} from '@@/utils/constant'
import { 
  FR4_DEFAULT_FORM, 
  PCB_DEFAULT_FORM,
  SMT_DEFAULT_FORM, 
  FR4_BOARD_DEFAULT_FORM 
} from '@@/utils/defaultForm'
import {
  isShowPcbParams,
  computePcbSize,
  pcsNumForSet,
  formatPcbParams
} from '@@/utils/pcbParamsFormat'
import { formatSmtParams } from '@@/utils/smtParamsFormat'
import { getPcbQuote, getPcbPrice } from '@@/api/pcb'
import { getSmtQuote, getSmtPrice } from '@@/api/smt'

// 自动引入 FR-4 相关字段的组件
const fr4Fields = require.context('@@/views/pcb/fields', true, /\.vue$/)
// 自动引入 ROGERS 相关字段的组件
const rogersFields = require.context('@@/views/pcb/rogers', true, /\.vue$/)
// 自动引入 CEM-1 相关字段的组件
const cem1Fields = require.context('@@/views/pcb/cem1', true, /\.vue$/)

// 需要根据 产品类别 使用不同组件的字段
const fieldsComponentNames = {
  'FR-4': {
    bheight: 'bheight',
    copper: 'copper',
    insidecopper: 'insidecopper',
    lineweight: 'lineweight',
    vias: 'vias',
    color: 'color',
    charcolor: 'charcolor',
    cover: 'cover',
    spray: 'spray',
    cjh: 'cjh',
    pressing: 'pressing',
    test: 'test',
  },
  'ROGERS': {
    bheight: 'rogers_bheight',
    copper: 'rogers_copper',
    insidecopper: 'rogers_insidecopper',
    lineweight: 'rogers_lineweight',
    vias: 'rogers_vias',
    color: 'rogers_color',
    cover: 'rogers_cover',
    spray: 'rogers_spray',
    cjh: 'rogers_cjh',
    pressing: 'rogers_pressing',

    charcolor: 'charcolor',
    test: 'test',
  },
  ...(['CEM-1', 'CEM-3', 'FR-1', '22F'].reduce((data, key) => {
    data[key] = {
      bheight: 'cem1_bheight',
      copper: 'cem1_copper',
      lineweight: 'cem1_lineweight',
      vias: 'cem1_vias',
      color: 'cem1_color',
      charcolor: 'cem1_charcolor',
      spray: 'cem1_spray',
      test: 'cem1_test',
    }
    return data
  }, {})),
}

export default {
  components: {
    ...registerComponents(fr4Fields),
    // 使用时需要带上 rogers_ 前缀
    ...registerComponents(rogersFields, 'rogers_'),
    // 使用时需要带上 cem1_ 前缀
    ...registerComponents(cem1Fields, 'cem1_'),
    MustSeeTips,
    Affix,
    SmtForm,
    QuoteRight,
    Iframe3D,
    AffixService,
    BoardDialog
  },
  directives: {
    anchorNav
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      isShowMustSeeLink: false,
      iframe3DConfig: {
        isShow: false, // 3Diframe：解析成功-显示，解析失败-隐藏
        loading: false, // 是否正在解析中
        analyze_id: '',
        key: 0
      },
      pcbParams: { ...FR4_DEFAULT_FORM },
      smtParams: { ...SMT_DEFAULT_FORM, order_info: { ...SMT_DEFAULT_FORM.order_info }, custom_pcb_ban: 1 },
      manufacture: 1, // 外发等于0
      pcbPrice: {}, // PCB价格
      smtPrice: {}, // SMT价格
      priceTotal: {}, // 订单总计价格
      testOptions: [], // 测试方式选项
      debounceGetPirce: debounce(this.getPrice, 300), // 计价接口防抖
      initPcbParamsChange: false, // 返回修改初始化参数时，参数不进行关联变更
      initDefaultPcbParamsChange: false, // 配置的初始化默认参数变更时
      ladderPriceTips: '', // 阶梯价提示
    }
  },
  // 向右侧侧边栏注入订单参数
  provide() {
    return {
      pcbParams: this.pcbParams,
      smtParams: this.smtParams,
      getPcbPrice: () => this.pcbPrice,
      getSmtPrice: () => this.smtPrice,
      getPriceTotal: () => this.priceTotal,
      pcbValidate: valids => this.validate(valids),
      smtValidate: valids => this.smtValidate(valids)
    }
  },
  computed: {
    // PCB站点
    isPcbSite() {
      return isPcbSite
    },
    // 相关字段是否显示判断
    isShow() {
      return isShowPcbParams(this.pcbParams)
    },
    // 是否需要SMT贴片
    isNeedSmt() {
      // return this.pcbParams.is_need_smt === 1
      // PCB下单与【smt贴片】字段不再交互
      return false
    },
    // 是否是从二级导航栏点击 HDI板计价 跳转过来的
    isHdi() {
      return this.$route.query.hdi == 1 || this.$route.query.board_type == 'HDI'
    },
    // 是否有DFM传值过来的json
    hasDfmSets() {
      return !!this.pcbParams.dfm_sets
    },
    // 板子面积
    area() {
      const { computePcbSize, pcbParams, pcbPrice } = this
      // 当计价接口还没返回时，使用拼板长宽计算面积
      return (pcbPrice.m || (computePcbSize.length * computePcbSize.width * pcbParams.bcount) || 0) / 10000
    },
    // 计算板子尺寸
    computePcbSize() {
      return computePcbSize(this.pcbParams)
    },
    // 连片数量换算为单片数量
    pcsNumForSet() {
      return pcsNumForSet(this.pcbParams)
    },
    // 是否禁用拼板工具相关参数
    isDisabledBoardParams() {
      // 出货形式是 连片(华秋代拼) 时，需要禁用拼板工具相关的参数
      return this.pcbParams.units == 2
    },
    // 板子面积提示
    areaTips() {
      const { 
        isShow, 
        area, 
        pcbParams: { length, width, bcount }
      } = this
      if (isShow.isCem1OrCem3OrFr1Or22f && length && width && bcount) {
        // CEM-1 CEM-3 FR-1 22F 面积不能小于5平米
        return area < 5 ? '订单面积不能小于5平米，请调整数量或尺寸' : ''
      }
      return ''
    }
  },
  watch: {
    pcbParams: {
      deep: true,
      handler: function (val) {
        this.debounceGetPirce()
      }
    },
    smtParams: {
      deep: true,
      handler: function (val) {
        this.debounceGetPirce()
      }
    }
  },
  async mounted() {
    let { id, type = 'PCB', board_type, hdi } = this.$route.query
    type = isNaN(Number(type)) ? type : ORDER_TYPE_ENUMS[type]
    if (id) {
      this.$store.dispatch('defaultValueConfig/getPcbDefaultValueConfig')
      this.pcbParams.is_need_smt = type.includes('SMT') ? 1 : 2
      this.getParams(id)
    } else {
      await this.initDefaultValueConfig()

      // 暂时隐藏 铝基板 铜基板
      if (['ALU', 'COPPER'].includes(board_type)) {
        // 新窗口打开
        window.open(`/quote?board_type=${board_type}`)
        return
      }

      if (board_type || hdi) {
        // 兼容旧的跳转参数
        if (hdi == 1) {
          // 填充HDI默认参数
          this.initParams('HDI')
        } else {
          this.initParams(board_type)
        }
      } else {
        this.initUrlParams()
      }
    }

    // 神策数据埋点
    sensorsTrack('PCB1_quotation_order_view', { entrance: '新版PCB计价页面浏览' })
  },
  methods: {
    // 获取组件名称
    getComponentName(component) {
      return fieldsComponentNames[this.pcbParams.board_type][component] || component
    },
    // 填充配置的初始化参数
    async initDefaultValueConfig() {
      // const isLogin = this.$store.state.orderUser.isLogin
      // if (!isLogin) return
      this.loading = true
      this.initDefaultPcbParamsChange = true
      await this.$store.dispatch('defaultValueConfig/getPcbDefaultValueConfig')
      const defaultValueConfig = this.$store.state.defaultValueConfig.PCB || {}
      const numberFields = getNumberOptionKeys('FR-4')
      const configData = Object.entries(defaultValueConfig).reduce((data, [key, val]) => {
        if (['none', 'default'].includes(val)) {
          data[key] = { 'none': '', 'default': FR4_DEFAULT_FORM[key] }[val]
        } else if (numberFields.includes(key)) {
          data[key] = Number(val)
        } else {
          data[key] = val
        }
        return data
      }, {})
      this.pcbParams = Object.assign(this.pcbParams, configData)
      this.loading = false
      this.$nextTick(() => {
        this.initDefaultPcbParamsChange = false
      })
    },
    // 填充相关产品类别的默认参数
    initParams(board_type) {
      this.initPcbParamsChange = true
      this.pcbParams = Object.assign(this.pcbParams, PCB_DEFAULT_FORM[board_type] || PCB_DEFAULT_FORM['FR-4'])
      this.$nextTick(() => {
        this.initPcbParamsChange = false
      })
    },
    // 填充url参数
    initUrlParams() {
      const routeQuery = this.$route.query
      // 需要添加 b 前缀的key
      const otherUrlParamKeys = ['count', 'layer', 'height', 'lind']
      const urlParamKeys = ['length', 'width', 'blayer', 'bcount', 'bheight', 'lineweight', ...otherUrlParamKeys]

      if (!urlParamKeys.some(key => routeQuery[key])) return

      // 数字类型的字段
      const numberFields = getNumberOptionKeys(['FR-4', 'ROGERS'])
      // 当url有带参数时，填充参数
      this.initPcbParamsChange = true
      const urlData = urlParamKeys.reduce((data, key) => {
        const val = routeQuery[key]
        const paramKey = otherUrlParamKeys.includes(key) ? `b${key}` : key
        data[paramKey] = val ? (numberFields.includes(paramKey) ? +val : val) : FR4_DEFAULT_FORM[paramKey]
        return data
      }, {})
      this.pcbParams = Object.assign(this.pcbParams, urlData)
      this.$nextTick(() => {
        this.initPcbParamsChange = false
      })
    },
    // 产品类别切换
    handleBoardTypeChange(val) {
      const defaultForm = PCB_DEFAULT_FORM[val] || {}
      // 需要保留的字段
      const unchangedForm = UNCHANGED_FIELDS.reduce((pre, cur) => {
        pre[cur] = this.pcbParams[cur]
        return pre
      }, {})

      this.pcbParams = Object.assign(this.pcbParams, defaultForm, unchangedForm)
    },

    // 文件解析成功
    handleAnalyzeFile(data) {
      const { file_type, blength, bwidth, blayer } = data || {}
      const { isRogers, isCem1OrCem3OrFr1Or22f } = this.isShow

      // 解析成功
      if (file_type != -1) {
        // 解析的板子层数为 2 且 罗杰斯的混压类型为 混压 时，将混压类型改为 纯压
        if (isRogers && blayer == 2 && this.pcbParams.hybrid_type == 2) {
          data.hybrid_type = 1
          alertFieldsTips('混压类型')
        }
        
        if (
          // 罗杰斯 解析的板子层数不在板子层数选项中 或 为禁用选项时
          (isRogers && ![2, 4, 6].includes(blayer)) ||
          // CEM-1 CEM-3 FR-1 22F 解析的板子层数不在板子层数选项中 或 为禁用选项时
          (isCem1OrCem3OrFr1Or22f && blayer != 1)
        ) {
          data.blayer = this.pcbParams.blayer
          this.$alert(`文件为${blayer}层板，华秋暂不支持`, '温馨提示', {
            confirmButtonText: '好的',
            lockScroll: false,
            center: true,
            customClass: 'alert-fields-tips',
            closeOnPressEscape: true
          })
        }
      }

      // 解析成功后，需要先重置拼板工具相关的字段
      this.pcbParams = Object.assign(
        this.pcbParams, 
        FR4_BOARD_DEFAULT_FORM, 
        data, 
        (file_type === -1 ? { length: this.pcbParams.length, width: this.pcbParams.width } : { length: blength, width: bwidth })
      )
    },
    // 3D数据解析成功
    handleAnalyze3DComplete(data = {}) {
      this.iframe3DConfig = Object.assign(this.iframe3DConfig, data)
    },

    // 需要转为 Number 类型的字段
    transformNumberFields(type, params) {
      const fields = Array.isArray(type) 
        ? type.reduce((keys, key) => [...new Set([...keys, ...getNumberOptionKeys(key)])], []) 
        : getNumberOptionKeys(type)

      return fields.reduce((data, key) => {
        if (params[key] !== undefined) {
          data[key] = Number(params[key])
        }
        return data
      }, {})
    },
    // PCB参数处理
    initPcbParams(params) {
      this.initPcbParamsChange = true
      const transformNumberFields = this.transformNumberFields(['FR-4', 'ROGERS'], params)
      const { report, pressing, pressing_computer_id, pressing_data, board_type, lack_handle_number } = params
      this.pcbParams = Object.assign(this.pcbParams, params, transformNumberFields, {
        // 产品报告
        report: report ? report.split(',') : ['无需'],
        // 叠层结构：当有计算id时，前端拼上计算id，用于区分接口返回的选项
        // 罗杰斯 为空时 选中 无需求
        pressing: pressing_computer_id ? `${pressing_computer_id}__${pressing}` : (board_type === 'ROGERS' ? pressing || '无需求' : pressing),
        // 叠层结构计算选项查看数据
        pressing_data: pressing_computer_id ? pressing_data : null,
        // 少数占比大于(如果返回 0 则置空)
        lack_handle_number: lack_handle_number || '',
      })
      this.$nextTick(() => {
        this.initPcbParamsChange = false
      })
    },
    // SMT参数处理
    initSmtParams(params) {
      const { smt_params, order_info = {} } = params
      const transformNumberFields = this.transformNumberFields('SMT', smt_params)
      this.smtParams = Object.assign(this.smtParams, smt_params, transformNumberFields, { order_info: {...order_info} })
    },
    // 获取订单信息
    async getParams(id) {
      try {
        this.loading = true
        this.isNeedSmt ? await this.getSmtParams(id) : await this.getPcbParams(id)
        this.$nextTick(() => {
          this.loading = false
        })
      } catch (error) {
        this.loading = false
      }
    },
    // 获取PCB订单信息
    async getPcbParams(quoteid) {
      //  kicad插件参数
      const guid = this.$route.query.guid
      return await getPcbQuote({ quoteid, guid })
        .then(res => {
          if (!res) return false
          const { retCode, retMsg, result } = res
          if (retCode === 0) {
            const { quote, extend, notify } = result
            const params = { ...extend, ...notify, ...quote, quoteid }
            this.initPcbParams(params)
          } else {
            this.$message.error(retMsg)
          }
        })
    },
    // 获取SMT订单信息
    async getSmtParams(smtTmpId) {
      return await getSmtQuote({ smtTmpId })
        .then(res => {
          if (!res) return false
          const { suc, body, msg } = res
          if (suc) {
            const { pcb_params, ...smt_params } = body
            // PCB参数处理
            this.initPcbParams(pcb_params)
            // SMT参数处理
            this.initSmtParams(smt_params)
          } else {
            this.$message.error(msg)
          }
        })
    },

    // 计价
    async getPrice() {
      const { length, width, bcount } = this.pcbParams
      // 尺寸、数量没填时不能计价
      if (!length || !width || !bcount) return
      // 需要SMT贴片时，调用SMT计价接口 否则调用PCB计价接口
      const res = this.isNeedSmt ? await this.getSmtPrice() : await this.getPcbPrice()

      const { detail = {} } = res
      const { pcb = {}, smt = {} } = detail
      const { suggest = {}, deltime, test, manufacture } = pcb

      this.pcbPrice = pcb
      this.smtPrice = smt
      this.priceTotal = res
      // 插入阶梯价提示
      this.priceTotal.ladderPriceTips = this.ladderPriceTips

      // 是否时外发
      this.manufacture = manufacture
      // 外发沉金厚度只能为1
      if (!this.isShow.isRogers && manufacture == 0 && this.pcbParams.spray === '沉金' && this.pcbParams.cjh != 1) {
        this.pcbParams.cjh = 1
        alertFieldsTips('沉金厚度')
      }

      // 测试方式选项
      this.testOptions = suggest.test
      this.pcbParams.test = test

      // 生产周期
      this.pcbParams.deltime = deltime
      this.pcbParams.standard_deltime = ((suggest.deltime || []).find(item => item.name === deltime) || {}).standard_deltime || ''
    },
    // PCB 计价
    async getPcbPrice() {
      // want_bonus_activity：获取优惠券列表
      const params = formatPcbParams(this.pcbParams, { want_bonus_activity: 1 })
      return await getPcbPrice(params)
        .then(res => {
          if (!res) return {}
          const { retCode, result } = res
          return retCode === 0 ? result : {}
        })
    },
    // SMT + PCB 计价
    async getSmtPrice() {
      const { pcbParams, smtParams } = this
      return await getSmtPrice({ pcb_params: formatPcbParams(pcbParams), ...formatSmtParams(smtParams) })
        .then(res => {
          if (!res) return {}
          const { suc, body } = res
          return suc ? body : {}
        })
    },

    scrollIntoView(key) {
      if (this.$refs[key]) {
        // 滚动到元素上面偏移50px的位置
        const top = this.$refs[key].$el.getBoundingClientRect().top
        scrollTop(top, -50)
      }
    },
    validate(data) {
      data.forEach((item, index) => {
        const ref = this.$refs[item.key]
        if (ref && ref.isShowError) {
          // 显示错误提示样式
          ref.isShowError(true, index === 0)
        }
      })
      const fristItem = data[0]
      this.$message.closeAll()
      this.$message({
        type: 'error',
        offset: 400,
        message: fristItem.tips
      })
      this.scrollIntoView(fristItem.key)
    },
    smtValidate(data) {
      this.$nextTick(() => {
        this.$refs.smtFormRef && this.$refs.smtFormRef.validate(data)
      })
    },

    // 显示拼板工具弹框
    handleOpenBoardDialog(preUnits) {
      this.$refs.BoardDialogRef.open(preUnits ? { units: preUnits } : {})
    },
    // 拼板工具弹框保存
    handleBoardConfirm(data) {
      // 修改拼板参数后需要清除DFM传值json
      this.pcbParams = Object.assign(this.pcbParams, { ...data, units: 2, dfm_sets: '' })
    },
    // 拼板工具弹框取消
    handleBoardCancel(preData) {
      this.pcbParams = Object.assign(this.pcbParams, preData || {})
    },
    // 重置拼板工具相关参数
    handleResetBoard() {
      // 重置时，不重置的字段
      // 需要清空 dfm_sets
      const { topImage, botImage, length, width } = this.pcbParams
      this.pcbParams = Object.assign(this.pcbParams, FR4_BOARD_DEFAULT_FORM, { topImage, botImage, length, width, dfm_sets: '' })
    },

    // 跳转新版
    handleGoNewversion() {
      this.$router.push({ path: '/quote' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/quote-container.scss';

.quote-container__header__right {
  display: flex;
  align-items: center;
  .quote-container__header__newversion {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    height: 32px;
    font-size: 13px;
    font-weight: 400;
    color: $--color-danger;
    border-radius: 16px;
    border: 1px solid $--color-danger;
    cursor: pointer;
    >span {
      margin-right: 6px;
    }
    &:hover {
      background-color: #fef6f6;
    }
  }
  .base-link {
    margin-left: 20px;
  }
}
</style>
<style lang="scss">
@import '~@@/styles/directives.scss';
</style>
